var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid text-center"},[_c('h1',{staticClass:"m-5"},[_vm._v("Error 404 Page not found")])])}]

export { render, staticRenderFns }